export default {
  // Inhalt des Modals
  model: {
    id: 0,
    name: '',
    short_name: '',

    forced: true
  },

  name: 'grave_types',

  validate () {
    return this.model.short_name.length <= 15
  },

	validateModel () {
		return true
	},

	copy (aModel) {
    this.model.id = aModel.id
    this.model.name = aModel.name
    this.model.short_name = aModel.short_name

    this.model.forced = true
  },

	// Die Spalten für die Tabelle
  cols: [
    {
      name: 'Bezeichnung',
      json: 'name',
      type: 'text'
    },
    {
      name: 'Kürzel',
      json: 'short_name',
      type: 'text'
    }
  ],

  clear () {
    this.model.id = 0
    this.model.name = ''
    this.model.forced = true
  }
}



// WEBPACK FOOTER //
// ./src/models/grave_types.js